module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-for-Creators-1.00a1b6d1.jpg";